import { exists } from '@/helpers/utilities';

const Tables = {
    selectors: {
        table: '.wp-block-table'
    },

    init(options = {}) {
        const selector = options.selector || this.selectors.table;
        const tables = document.querySelectorAll(selector);
        if (!tables.length) return;

        tables.forEach((table) => this.modifyTableBlock(table));
    },

    modifyTableBlock(node) {
        if (!exists(node)) return;
        
        // Add tabindex for keyboard accessibility
        node.setAttribute('tabindex', '0');
    }
};

export default Tables;
